import ImageBox from './main.vue';
import { ImageBoxType } from './type'


export { ImageBoxType };
export default ImageBox;
